import { blocksToPlainText } from './blocksToPlainText'

/** @typedef {import('./types.js').NoteContentBlock} NoteContentBlock */

/**
 * Sidebar preview line from structured content or fallback body.
 * @param {NoteContentBlock[] | undefined} content
 * @param {string} [body]
 * @param {number} [maxLen]
 */
export function noteContentPreview(content, body = '', maxLen = 140) {
  if (content?.length) {
    for (const block of content) {
      if (block.type === 'paragraph' && block.text.trim()) {
        const t = block.text.trim()
        return t.length <= maxLen ? t : `${t.slice(0, maxLen - 1)}…`
      }
    }
    for (const block of content) {
      if (block.type === 'heading' && block.text.trim()) {
        const t = block.text.trim()
        return t.length <= maxLen ? t : `${t.slice(0, maxLen - 1)}…`
      }
    }
    const flat = blocksToPlainText(content).trim()
    if (flat) return flat.length <= maxLen ? flat : `${flat.slice(0, maxLen - 1)}…`
  }

  const trimmed = String(body ?? '').trim()
  if (!trimmed) return ''
  return trimmed.length <= maxLen ? trimmed : `${trimmed.slice(0, maxLen - 1)}…`
}
